import EditPalette from './EditPalette.component';

export default EditPalette;
